module.exports = "/assets/data/a5eb7b4225e3eeb24ebb4bc8c3d8fd2d-LS19.data.json";